<template>
  <div class="row">
    <div class="col-md-12" >
      <!-- @input="selectedOnChange()" -->
      <div class="school-filter-bar">
        <v-select style="width:78%;" multiple v-model="selected" :options="options"></v-select>
        <button
            style="margin-left:5px; width:20%;"
            type="button"
            class="btn btn-default"
            @click="searchClicked"
        >篩選學校動態</button>
          
      </div>
    </div>    
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  props: ["options", "queries"],
  data: function() {
    return {
      selected: [],
      isInit: true
    };
  },
  mounted() {
    console.log("options", this.options, this.queries);
    if (this.isInit) {
      this.selected = this.queries;
      //   this.selected.push(this.queries);
      console.log("init selected", this.selected);
      this.isInit = false;
    }
  },
  methods: {
    searchClicked() {
      //   console.log("search clicked", this.selected);
      this.submitSearch();
    },
    submitSearch() {
      if (this.selected.length > 0) {
        // this.params = this.selected.join("&");
        var params = "?";
        this.selected.forEach(element => {
          //   console.log("element = ", element);
          params = params + "school_names[]=" + element + "&";
          //   console.log("params ", params);
        });
        window.location.href = "/campus/" + encodeURI(params);
      } else {
        window.location.href = "/campus";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.school-filter-bar{
    margin-bottom:20px;
      display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: normal;
  align-content: stretch;
}
</style>


// WEBPACK FOOTER //
// resources/js/campus/CampusListSchoolSelect.vue